module.exports = __webpack_public_path__ + "static/img/win5.7647772c.png";